import NotInterestedIcon from "@material-ui/icons/NotInterested";
import SwapHorizontalCircleIcon from "@material-ui/icons/SwapHorizontalCircle";

const displayInheritWording = [
  {
    inherit: false,
    title: "引継ぎ設定開始",
    description: "引継ぎ設定を開始しますか？",
    submitText: "引継ぎ設定開始",
    icon: SwapHorizontalCircleIcon
  },
  {
    inherit: true,
    title: "引継ぎ設定解除",
    description: "引継ぎ設定を解除しますか？",
    submitText: "引継ぎ設定解除",
    icon: SwapHorizontalCircleIcon
  },
  {
    inherit: "default",
    title: "引継ぎ設定変更",
    description: "",
    submitText: "",
    icon: SwapHorizontalCircleIcon
  }
];
const displayProhibitWording = [
  {
    isProhibit: false,
    title: "利用停止 　",
    description: "ユーザの利用を停止しますか？",
    submitText: "停止",
    icon: NotInterestedIcon
  },
  {
    isProhibit: true,
    title: "利用再開 　",
    description: "ユーザの利用を再開しますか？",
    submitText: "再開",
    icon: NotInterestedIcon
  },
  {
    isProhibit: "default",
    title: "利用状態変更",
    description: "",
    submitText: "",
    icon: NotInterestedIcon
  }
];

export { displayInheritWording, displayProhibitWording };
